import BorrowerOnboarding from './borrower-onboarding';

export default BorrowerOnboarding;
